import { WhitelabelConfig } from "../config/whitelabel";

export interface ItemMenu {
  rota: string;
  rotulo: string;
  icone: string;
  // Link de saida (abre em aba nova), em vez de rota interna do M7 - usado
  // pelo GIS (M13, app separado). Decisao registrada em DevGIS/secao 3.7.
  href?: string;
}

const CHAVE_RECOLHIDA = "telemetria_sidebar_recolhida";

// Icones modernos (outline, tom branco via currentColor) em vez de emoji -
// SVG inline, sem dependencia nova (mesmo espirito de manter o M7 leve).
const ICONE_DASHBOARD = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>`;
const ICONE_TABELA = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="1"/><line x1="3" y1="10" x2="21" y2="10"/><line x1="9" y1="10" x2="9" y2="20"/></svg>`;
const ICONE_GRAFICO = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 17 9 11 13 15 21 5"/><polyline points="14 5 21 5 21 12"/></svg>`;
const ICONE_MAPA = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>`;
const ICONE_ALERTAS = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>`;
const ICONE_CONFIG = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>`;
const ICONE_GIS = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3V6z"/><path d="M9 3v15"/><path d="M15 6v15"/></svg>`;

// "configuracoes" nunca e' restringida pelo pageAccess do usuario (todo
// usuario precisa poder trocar a propria senha).
export const ITENS_MENU: ItemMenu[] = [
  { rota: "dashboard", rotulo: "Dashboard", icone: ICONE_DASHBOARD },
  { rota: "tabela", rotulo: "Tabela", icone: ICONE_TABELA },
  { rota: "grafico", rotulo: "Gráfico", icone: ICONE_GRAFICO },
  { rota: "mapa", rotulo: "Mapa", icone: ICONE_MAPA },
  { rota: "alertas", rotulo: "Alertas", icone: ICONE_ALERTAS },
  // Link de saida pro M13 (GIS), app separado - abre em aba nova (ver
  // main.ts). Path relativo: funciona tanto no ambiente de testes quanto
  // em producao, onde M13 entra como /m13-gis/ no mesmo dominio do M7
  // (mesmo padrao de M9/M10/M12), nao um dominio dedicado.
  { rota: "gis", rotulo: "GIS", icone: ICONE_GIS, href: "/m13-gis/" },
  { rota: "configuracoes", rotulo: "Configurações", icone: ICONE_CONFIG },
];

const SEMPRE_LIBERADA = new Set(["configuracoes"]);

// pageAccess vazio = irrestrito (compatibilidade); lista nao vazia = allowlist.
export function itensPermitidos(pageAccess: string[]): ItemMenu[] {
  if (pageAccess.length === 0) return ITENS_MENU;
  return ITENS_MENU.filter((item) => SEMPRE_LIBERADA.has(item.rota) || pageAccess.includes(item.rota));
}

export function sidebarRecolhida(): boolean {
  return localStorage.getItem(CHAVE_RECOLHIDA) === "1";
}

export function alternarSidebarRecolhida(): boolean {
  const nova = !sidebarRecolhida();
  localStorage.setItem(CHAVE_RECOLHIDA, nova ? "1" : "0");
  return nova;
}

export function renderSidebar(config: WhitelabelConfig, rotaAtiva: string, pageAccess: string[] = []): string {
  const recolhida = sidebarRecolhida();
  const links = itensPermitidos(pageAccess)
    .map(
      (item) => `
      <button class="sidebar__link${item.rota === rotaAtiva ? " ativo" : ""}" data-rota="${item.rota}"${item.href ? ` data-href="${item.href}"` : ""} title="${item.rotulo}">
        <span class="sidebar__icone">${item.icone}</span> <span class="sidebar__rotulo">${item.rotulo}</span>
      </button>`
    )
    .join("");

  return `
    <aside class="sidebar${recolhida ? " sidebar--recolhida" : ""}" id="sidebar">
      <div class="sidebar__topo">
        <div class="sidebar__logo">
          <img src="${config.brand.logoUrl}" alt="${config.brand.name}" />
        </div>
        <button class="sidebar__alternar" id="sidebar-alternar" title="${recolhida ? "Expandir menu" : "Recolher menu"}">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="${recolhida ? "9 18 15 12 9 6" : "15 18 9 12 15 6"}"/></svg>
        </button>
      </div>
      <nav class="sidebar__nav">${links}</nav>
    </aside>
  `;
}
